webpackJsonp([1],Array(25).concat([
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHotSearchKeysmod */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRecomList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAlbumList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsonp__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__API__ = __webpack_require__(53);




var getHotSearchKeysmod = function getHotSearchKeysmod() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jsonp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__API__["a" /* hotSearchKeysmod */], {
        params: {
            jsonpCallback: 'hotSearchKeysmod_top_search'
        }
    });
};

var getRecomList = function getRecomList() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jsonp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__API__["b" /* recomList */], {
        params: {
            tpl: 'v12',
            page: 'other',
            callback: 'GetRecomListCallback5053087508676672',
            rnd: '5053087508676672',
            jsonpCallback: 'GetRecomListCallback5053087508676672'
        }
    });
};

var defaultConfig = {
    cmd: 'firstpage',
    page: 0,
    pagesize: 20,
    language: -1,
    genre: 0,
    year: 1,
    pay: 0,
    type: -1,
    company: -1,
    sort: 1
};
var getAlbumList = function getAlbumList(options) {
    options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultConfig, options);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__jsonp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__API__["c" /* albumList */], {
        params: {
            jsonpCallback: 'GetAlbumListJsonCallback',
            cmd: options.cmd,
            page: options.page,
            pagesize: options.pagesize || 20,
            sort: options.sort,
            language: options.language,
            genre: options.genre,
            year: options.year,
            pay: options.pay,
            type: options.type,
            company: options.company
        }
    });
};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestAnimationFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cancelAnimationFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_each__);


var lastTime = 0;
var ROOT = window;

var requestAnimationFrame = ROOT.requestAnimationFrame || ROOT.webkitRequestAnimationFrame || ROOT.mozRequestAnimationFrame || ROOT.msRequestAnimationFrame || function (callback) {
    var currTime = Date.now();
    var delay = Math.max(1000 / 60, 1000 / 60 - (currTime - lastTime));
    lastTime = currTime + delay;
    return setTimeout(callback, delay);
};

var cancelAnimationFrame = ROOT.cancelAnimationFrame || ROOT.webkitCancelAnimationFrame || ROOT.webkitCancelRequestAnimationFrame || ROOT.mozCancelRequestAnimationFrame || ROOT.msCancelRequestAnimationFrame || clearTimeout;

var getTransform = function getTransform() {
    var divStyle = document.createElement('div').style;
    var styleTransform = null;

    __WEBPACK_IMPORTED_MODULE_0_lodash_each___default()(['transform', 'WebkitTransform', 'mozTransform', 'msTransform'], function (ts) {
        if (ts in divStyle) {
            styleTransform = ts;
        }
    });

    return styleTransform;
};

var getStyle = function getStyle(elem, name) {
    return elem.currentStyle ? elem.currentStyle[name] : document.defaultView.getComputedStyle(elem, false)[name];
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_Index__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_Profile__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_Discover__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_Discover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_Discover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_Album__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_Album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_Album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Mv__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_Mv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_Mv__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'app',
        component: __WEBPACK_IMPORTED_MODULE_2_app___default.a,
        redirect: '/index',
        children: [{
            path: '/index',
            name: 'Index',
            component: __WEBPACK_IMPORTED_MODULE_3_pages_Index___default.a
        }, {
            path: '/profile',
            name: 'Profile',
            component: __WEBPACK_IMPORTED_MODULE_4_pages_Profile___default.a
        }, {
            path: '/discover',
            name: 'Discover',
            component: __WEBPACK_IMPORTED_MODULE_5_pages_Discover___default.a
        }]
    }, {
        path: '/album',
        name: 'Album',
        component: __WEBPACK_IMPORTED_MODULE_6_pages_Album___default.a
    }, {
        path: '/mv',
        name: 'mv',
        component: __WEBPACK_IMPORTED_MODULE_7_pages_Mv___default.a
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_top__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_router__ = __webpack_require__(50);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__app_router__["a" /* default */],
    template: '<Top/>',
    components: { Top: __WEBPACK_IMPORTED_MODULE_1__app_top___default.a }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hotSearchKeysmod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recomList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return albumList; });

var qqHost = 'https://c.y.qq.com';

var hotSearchKeysmod = qqHost + '/splcloud/fcgi-bin/gethotkey.fcg';

var recomList = qqHost + '/v8/fcg-bin/fcg_first_yqq.fcg';

var albumList = qqHost + '/v8/fcg-bin/album_library';

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_each__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_each__);





var defaultConfig = {
    g_tk: 5831,
    loginUin: 0,
    hostUin: 0,
    format: 'jsonp',
    inCharset: 'utf8',
    outCharset: 'utf-8',
    notice: 0,
    platform: 'yqq',
    needNewCode: 0
};

/* harmony default export */ __webpack_exports__["a"] = (function (url, options) {
    options.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultConfig, options.params);
    var connect = /\?/.test(url) ? '&' : '?';
    var param = connect;

    __WEBPACK_IMPORTED_MODULE_3_lodash_each___default()(options.params, function (item, key) {
        param += '&' + key + '=' + item;
    });

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_jsonp___default()(url, {
            param: param,
            name: options.params.jsonpCallback || '__jp',
            timeout: options.timeout || 60000,
            prefix: options.prefix || '__jp'
        }, function (error, data) {
            return data ? resolve(data.data) : reject(error);
        });
    });
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestAnimationFrame__ = __webpack_require__(26);


var styleTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__requestAnimationFrame__["a" /* getTransform */])();

/* harmony default export */ __webpack_exports__["a"] = (function (elem, target, callback) {
    var duration = 600;
    var easein = function easein(t, b, c, d) {
        return c * (t /= d) * t + b;
    };

    var stime = +new Date();
    var timer = null;

    var ani = function ani() {
        var offset = Math.min(duration, +new Date() - stime);
        var s = easein(offset, 0, 1, duration);
        var currentX = parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__requestAnimationFrame__["b" /* getStyle */])(elem, 'transform').match(/-?[0-9.]+/g)[4]);
        var resX = (target - currentX) * s + currentX;
        elem.style[styleTransform] = 'translate(' + resX.toFixed(2) + 'px, 0)';

        if (offset !== duration) {
            timer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__requestAnimationFrame__["c" /* requestAnimationFrame */])(ani);
        } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__requestAnimationFrame__["d" /* cancelAnimationFrame */])(timer);
            callback && callback();
        }
    };

    ani();
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            tabs: [{ path: '/index', title: '主页' }, { path: '/profile', title: '我的' }, { path: '/discover', title: '发现' }],
            index: 0
        };
    },

    methods: {
        linkTo: function linkTo(index) {
            this.index = index;
        }
    }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'top'
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_moveTo__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_requestAnimationFrame__ = __webpack_require__(26);





var pages = [{
    url: 'xxx',
    style: {
        backgroundColor: 'orange'
    },
    title: 'Banner1'
}, {
    url: 'xxx',
    style: {
        backgroundColor: 'pink'
    },
    title: 'Banner2'
}, {
    url: 'xxx',
    style: {
        backgroundColor: '#cccccc'
    },
    title: 'Banner3'
}];
var options = {
    duration: 600,
    direction: 1,
    start: 0,
    loop: false,
    transition: 'slide',
    autoplay: false,
    interval: 3000 };

var deviceWidth = document.body.clientWidth;
var styleTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_utils_requestAnimationFrame__["a" /* getTransform */])();
var ismobile = 'ontouchstart' in document;

var startX = 0;
var targetSourceX = 0;
var disX = 0;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'slider',
    props: {
        pages: {
            type: Array,
            default: function _default() {
                return pages;
            }
        },
        options: {
            type: Object,
            default: function _default() {
                return options;
            }
        }
    },
    data: function data() {
        return {
            isAnimation: false,
            isCanStart: true,
            startX: 0,
            targetSourceX: 0,
            index: 0
        };
    },

    computed: {},
    mounted: function mounted() {
        var target = this.$el.children[0];

        startX = 0;
        targetSourceX = 0;

        target.style.width = target.children.length * deviceWidth + 'px';

        if (ismobile) {
            target.addEventListener('touchstart', this.handlerMousedown, false);
            target.addEventListener('touchmove', this.handlerMousemove, false);
            target.addEventListener('touchend', this.handlerMouseup, false);
        } else {
            target.addEventListener('mousedown', this.handlerMousedown, false);
        }
    },
    destory: function destory() {
        var target = this.$el.children[0];
        target.removeEventListener('touchstart', this.handlerMousedown, false);
        target.removeEventListener('touchmove', this.handlerMousemove, false);
        target.removeEventListener('touchend', this.handlerMouseup, false);
    },

    methods: {
        handlerMousedown: function handlerMousedown(event) {
            if (this.isAnimation) {
                return;
            }
            event.preventDefault();
            console.log('start');
            this.isCanStart = true;
            startX = ismobile ? event.changedTouches[0].pageX : event.clientX;

            if (!ismobile) {
                document.addEventListener('mousemove', this.handlerMousemove, false);
                document.addEventListener('mouseend');
            }
        },
        handlerMousemove: function handlerMousemove(event) {
            if (this.isAnimation || !this.isCanStart) {
                return;
            }
            event.preventDefault();
            console.log('move');
            var currentX = ismobile ? event.changedTouches[0].pageX : event.clientX;
            disX = currentX - startX;
            var targetCurrentX = targetSourceX + disX;
            this.$el.children[0].style[styleTransform] = 'translate(' + targetCurrentX + 'px, 0)';
        },
        handlerMouseup: function handlerMouseup(event) {
            if (this.isAnimation || !this.isCanStart) {
                return;
            }
            console.log('end');
            var self = this;
            this.isAnimation = true;
            this.isCanStart = false;

            var destination = 0;

            if (disX <= 50 || disX >= -50) {
                destination = targetSourceX;
            }

            if (disX > 50) {
                if (this.index > 0) {
                    this.index -= 1;
                }
                destination = -this.index * deviceWidth;
            }

            if (disX < -50) {
                if (this.index < this.$el.children[0].children.length - 1) {
                    this.index += 1;
                }
                destination = -this.index * deviceWidth;
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_utils_moveTo__["a" /* default */])(this.$el.children[0], destination, function () {
                targetSourceX = destination;
                self.isAnimation = false;
            });
        }
    },
    watch: {
        pages: function pages(newPages) {
            this.$el.children[0].style.width = newPages.length * deviceWidth + 'px';
        }
    }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'album-list'
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'discover'
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_request__ = __webpack_require__(25);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'album',
    data: function data() {
        return {
            albumList: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_utils_request__["b" /* getAlbumList */]({ cmd: 'get_album_info', pagesize: 6 }).then(function (resp) {
            _this.albumList = resp.albumlist.map(function (item) {
                item.album_cover_style = {
                    backgroundImage: 'url(https://y.gtimg.cn/music/photo_new/T002R300x300M000' + item.album_mid + '.jpg)'
                };
                return item;
            });
        });
    }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hotdidss',
    props: ['disslist']
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_request__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_slider__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__album__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hotdiss__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hotdiss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hotdiss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shoubomv__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shoubomv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__shoubomv__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'index',
    data: function data() {
        return {
            message: 'this is a message',
            focus: [],
            hotdissList: [],
            shoubomv: {},
            toplist: [] };
    },

    components: { slider: __WEBPACK_IMPORTED_MODULE_1_components_slider___default.a, album: __WEBPACK_IMPORTED_MODULE_2__album___default.a, hotdiss: __WEBPACK_IMPORTED_MODULE_3__hotdiss___default.a, shoubomv: __WEBPACK_IMPORTED_MODULE_4__shoubomv___default.a },
    computed: {
        counter: function counter() {
            return 20 + 30;
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_utils_request__["a" /* getRecomList */]().then(function (resp) {
            console.log(resp);
            _this.focus = resp.focus.map(function (item) {
                return {
                    url: item.jumpurl ? item.jumpurl : 'https://y.qq.com/n/yqq/album/' + item.id + '.html',
                    style: {
                        backgroundImage: 'url(' + item.pic + ')'
                    }
                };
            });
            _this.hotdissList = resp.hotdiss.list.map(function (item) {
                item.style = {
                    backgroundImage: 'url(' + item.imgurl + ')'
                };
                return item;
            });
            _this.shoubomv = resp.shoubomv.all.map(function (item) {
                item.style = {
                    backgroundImage: 'url(' + item.picurl + ')'
                };
                item.url = 'https://y.qq.com/n/yqq/mv/v/' + item.vid + '.html';
                return item;
            });
            _this.toplist = resp.toplist;
        });
    }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'shoubomv',
    props: ['mvlist']
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'mv-list'
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile'
});

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-62e1482a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-7326409a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-7336cdee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [_c('slider', {
    attrs: {
      "pages": _vm.focus
    }
  }), _vm._v(" "), _c('album'), _vm._v(" "), _c('hotdiss', {
    attrs: {
      "disslist": _vm.hotdissList
    }
  }), _vm._v(" "), _c('shoubomv', {
    attrs: {
      "mvlist": _vm.shoubomv
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', [_c('router-view', {
    attrs: {
      "keep-alive": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-list-container"
  }, [_vm._v("\n    mv列表页\n")])
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoubomv-container"
  }, [_c('div', {
    staticClass: "shoubomv-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("首播MV")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/mv"
    }
  }, [_c('span', {
    staticClass: "arrow"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "shoubomv-body"
  }, _vm._l((_vm.mvlist), function(item) {
    return _c('div', {
      staticClass: "shoubomv-item-box"
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "mv-cover",
      style: (item.style)
    }), _vm._v(" "), _c('div', {
      staticClass: "info-mask"
    }, [_c('div', {
      staticClass: "mv-title"
    }, [_vm._v(_vm._s(item.mvtitle))]), _vm._v(" "), _c('div', {
      staticClass: "mv-singer"
    }, [_vm._v(_vm._s(item.singer_name))]), _vm._v(" "), _c('div', {
      staticClass: "listennum"
    }, [_vm._v("已播放" + _vm._s(item.listennum) + "次")])])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-container"
  }, [_c('div', {
    staticClass: "album-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("新歌速递")]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/album"
    }
  }, [_c('span', {
    staticClass: "arrow"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "album-body"
  }, _vm._l((_vm.albumList), function(item) {
    return _c('div', {
      staticClass: "album-item-box"
    }, [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('div', {
      staticClass: "album-cover",
      style: (item.album_cover_style)
    }), _vm._v(" "), _c('div', {
      staticClass: "info-mask"
    }, [_c('div', {
      staticClass: "album-name"
    }, [_vm._v(_vm._s(item.album_name))]), _vm._v(" "), _c('div', {
      staticClass: "singer"
    }, [_vm._v(_vm._s(item.singer_name))])])])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotdiss-container"
  }, [_c('div', {
    staticClass: "hotdiss-header"
  }, [_vm._v("热门歌单")]), _vm._v(" "), _c('div', {
    staticClass: "hotdiss-body"
  }, _vm._l((_vm.disslist), function(item) {
    return _c('div', {
      staticClass: "hotdiss-item-box"
    }, [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('div', {
      staticClass: "diss-cover",
      style: (item.style)
    }), _vm._v(" "), _c('div', {
      staticClass: "info-mask"
    }, [_c('div', {
      staticClass: "diss-name"
    }, [_vm._v(_vm._s(item.dissname))]), _vm._v(" "), _c('div', {
      staticClass: "listennum"
    }, [_vm._v("已播放" + _vm._s(item.listennum) + "次")])])])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    staticClass: "slides"
  }, [(!_vm.options.loop) ? [_vm._l((_vm.pages), function(item, i) {
    return [_c('a', {
      staticClass: "slide",
      style: (item.style),
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.title))])]
  })] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [_vm._v("发现模块")])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrap"
  }, [_vm._v("this is profile component")])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-list-container"
  }, [_vm._v("\n    专辑列表页\n")])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-container"
  }, [_c('nav', _vm._l((_vm.tabs), function(tab, i) {
    return _c('router-link', {
      key: "{i}",
      class: {
        active: _vm.index === i
      },
      attrs: {
        "to": tab.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.linkTo(i)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    attrs: {
      "keep-alive": ""
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ })
]),[52]);


// WEBPACK FOOTER //
// static/js/app.9dbcd2384dfe2c30999d.js